import { useEffect, useState } from "react";
import axios from "axios";
import { motion, AnimatePresence } from "framer-motion";
import { LASERCUT } from "@/constants/testIds";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FILTERS = [
  { slug: "all", label: "Semua" },
  { slug: "gazebo", label: "Gazebo & Pergola" },
  { slug: "furniture", label: "Kursi & Furniture" },
  { slug: "bbq", label: "BBQ & Fire Pit" },
  { slug: "fence", label: "Pagar & Partisi" },
  { slug: "wallart", label: "Wall Art & Signage" },
  { slug: "table", label: "Meja & Planter" },
];

export const Portfolio = () => {
  const [items, setItems] = useState([]);
  const [active, setActive] = useState("all");

  useEffect(() => {
    axios
      .get(`${API}/portfolio`)
      .then((res) => setItems(res.data))
      .catch((err) => console.error("Failed loading portfolio", err));
  }, []);

  const filtered = active === "all" ? items : items.filter((i) => i.category === active);

  return (
    <section id="portofolio" className="relative bg-iron py-24 md:py-36 px-6 md:px-12 lg:px-24">
      <div className="max-w-2xl mb-10">
        <span className="text-xs uppercase tracking-[0.25em] text-brass">Portofolio</span>
        <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl tracking-tight text-chromed mt-4">
          Proyek yang sudah menjadi kenyataan
        </h2>
      </div>

      <div className="flex flex-wrap gap-3 mb-14">
        {FILTERS.map((f) => (
          <button
            key={f.slug}
            data-testid={LASERCUT.portfolioFilter(f.slug)}
            onClick={() => setActive(f.slug)}
            className={`text-xs uppercase tracking-[0.15em] px-4 py-2 border transition-colors ${
              active === f.slug
                ? "border-brass bg-brass text-ink"
                : "border-linecol text-chromed/60 hover:text-chromed hover:border-chromed/40"
            }`}
          >
            {f.label}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <AnimatePresence mode="popLayout">
          {filtered.map((item) => (
            <motion.div
              key={item.id}
              data-testid={LASERCUT.portfolioCard(item.id)}
              layout
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.9 }}
              transition={{ duration: 0.4 }}
              className="group relative aspect-[3/4] overflow-hidden border border-linecol"
            >
              <img
                src={item.image_url}
                alt={item.title}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-ink/0 group-hover:bg-ink/70 transition-colors duration-300 flex items-end p-5">
                <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 translate-y-2 group-hover:translate-y-0">
                  <p className="text-[10px] uppercase tracking-[0.2em] text-brass mb-1">
                    {item.category_label}
                  </p>
                  <h4 className="font-heading text-lg text-chromed">{item.title}</h4>
                </div>
              </div>
            </motion.div>
          ))}
        </AnimatePresence>
      </div>
    </section>
  );
};
